'use es6';

import tinymce from 'tinymce';
import ContentAssistancePopoverManager from '../../components/ContentAssistancePopoverManager';
import { getPickerComponent } from '../../utils/settings';
import { HS_CONTENT_GENERATION_INPAGE } from '../../constants/plugins';
import { jsx as _jsx } from "react/jsx-runtime";
export const addControls = (editor, selectionCommands, brandVoiceOptions) => {
  const ContentAssistanceToolbar = getPickerComponent(editor, 'ContentAssistanceToolbar', '`ContentAssistanceToolbar` picker component is required for the content generation plugin');
  tinymce.canvas.addPopover(editor, HS_CONTENT_GENERATION_INPAGE, {
    renderPopover: renderProps => {
      return /*#__PURE__*/_jsx(ContentAssistancePopoverManager, Object.assign({
        brandVoiceOptions: brandVoiceOptions,
        "data-test-id": "content-assistance-selection-popover",
        editor: editor,
        selectionCommands: selectionCommands,
        ContentAssistanceToolbar: ContentAssistanceToolbar
      }, renderProps));
    }
  });
};